import classNames from "classnames";
import { useContext, useState } from "react";
import { useLocation } from "react-router";

import { PROJECT_TABS } from "src/app/modules/admin/components/projects/constants";
import projectCSS from "src/app/modules/user-projects/Projects.module.css";
import { AuthContext } from "src/contexts/AuthContext";

import ProjectsTable from "./components/Projects";
import Statistics from "./components/Statistics";

function Projects() {
  const authData = useContext(AuthContext);
  const location = useLocation();
  const state = location.state as any;

  const filteredRegionIds = state?.regionId ? [state.regionId] : authData?.auth?.regionIds?.length ? authData.auth.regionIds : [];
  const filteredPartnerIds = state?.partnerIds ? state?.partnerIds : [];
  const filteredSystemIds = state?.systemId ? [state?.systemId] : [];
  const filteredTargetGroups = state?.targetGroup ? [state?.targetGroup] : [];

  const [activeTab, setActiveTab] = useState(PROJECT_TABS.PROJECTS);

  const [filteredRegionList, setFilteredRegionList] = useState<Array<number>>(filteredRegionIds);
  const [filteredPartnerList, setFilteredPartnerList] = useState<Array<number>>(filteredPartnerIds);
  const [filteredCityList, setFilteredCityList] = useState<Array<number>>([]);
  const [filteredSystemList, setFilteredSystemList] = useState<Array<number>>(filteredSystemIds);
  const [filteredTargetGroupList, setFilteredTargetGroupList] = useState<Array<number>>(filteredTargetGroups);
  const [filteredDateFrom, setFilteredDateFrom] = useState<Date | undefined>(state?.filteredDateFrom ? state!.filteredDateFrom : undefined);
  const [filteredDateTo, setFilteredDateTo] = useState<Date | undefined>(state?.filteredDateFrom ? state.filteredDateTo : undefined);

  return (
    <div className="u-bg-background u-flex u-col-lg-12 u-border-box u-flex-content-between u-flex-wrap">
      <div className={classNames("u-border-box", "u-bg-white", "u-pt10per", "u-col-xs-12", projectCSS.tabsContainer)}>
        <button
          className={classNames(
            activeTab === PROJECT_TABS.PROJECTS ? "active u-bg-background" : "u-bg-white",
            "u-col-xs-6",
            "u-t-uppercase",
            "u-t-f18p",
            "u-h100",
            "u-flex",
            "u-flex-content-center",
            "u-flex-items-center",
            "u-cursor-pointer"
          )}
          onClick={() => setActiveTab(PROJECT_TABS.PROJECTS)}
        >
          <h5 className={classNames(activeTab === PROJECT_TABS.PROJECTS ? "active u-t-primary" : "u-t-secondary", projectCSS.tabBtn)}>Upiti</h5>
        </button>
        <button
          className={classNames(
            activeTab === PROJECT_TABS.PARTNER_STATISTICS ? "active u-bg-background" : "u-bg-white",
            "u-col-xs-6",
            "u-t-uppercase",
            "u-t-f18p",
            "u-flex",
            "u-flex-content-center",
            "u-flex-items-center",
            "u-cursor-pointer"
          )}
          onClick={() => setActiveTab(PROJECT_TABS.PARTNER_STATISTICS)}
        >
          <h5 className={classNames(activeTab === PROJECT_TABS.PARTNER_STATISTICS ? "active u-t-primary" : "u-t-secondary", projectCSS.tabBtn)}>
            Statistika Partnera
          </h5>
        </button>
      </div>
      <ProjectsTable
        activeTab={activeTab}
        filteredPartnerList={filteredPartnerList}
        filteredRegionList={filteredRegionList}
        filteredCityList={filteredCityList}
        filteredSystemList={filteredSystemList}
        filteredTargetGroupList={filteredTargetGroupList}
        filteredDateFrom={filteredDateFrom}
        filteredDateTo={filteredDateTo}
        setFilteredPartnerList={setFilteredPartnerList}
        setFilteredRegionList={setFilteredRegionList}
        setFilteredCityList={setFilteredCityList}
        setFilteredSystemList={setFilteredSystemList}
        setFilteredTargetGroupList={setFilteredTargetGroupList}
        setFilteredDateFrom={setFilteredDateFrom}
        setFilteredDateTo={setFilteredDateTo}
      />
      <Statistics
        activeTab={activeTab}
        filteredPartnerList={filteredPartnerList}
        filteredRegionList={filteredRegionList}
        filteredCityList={filteredCityList}
        filteredSystemList={filteredSystemList}
        filteredTargetGroupList={filteredTargetGroupList}
        filteredDateFrom={filteredDateFrom}
        filteredDateTo={filteredDateTo}
      />
    </div>
  );
}

export default Projects;
